export const COLORS = {
  patientInfo: {
    light: '#6791C7',
    dark: '#6B819C',
  },
  careTeam: {
    light: '#C758A1',
    dark: '#9C5F87',
  },
  education: {
    light: '#C7A667',
    dark: '#9C8B6B',
  },
  onboarding: {
    light: '#FFDADB',
    dark: '#730D0E',
  },
  payment: {
    light: '#72C767',
    dark: '#719C6B',
  },
  statement: {
    light: '#636970',
    dark: '#353D46',
  },
  card: {
    light: '#FFDADB',
    dark: '#730D0E',
  },
  profile: {
    light: '#1A237E',
    dark: '#0D1B2A',
  },
  buttons: {
    greenDark: '#73710D',
    greenLight: '#F2F194',
    redDark: '#720D0F',
    redLight: '#C8595A',
    blueDark: '#0D4C73',
    blueLight: '#94CFF2',
  },
};
